import { useNavigate, useParams } from "react-router-dom";
import { ButtonGroup } from "../../components/buttons/ButtonGroup";
import {
  PageContainer,
  PageContentContainer,
} from "../../components/PageContainer";
import { InfoText } from "../../components/texts/InfoText";

export const UserAppRating = () => {
  const navigate = useNavigate();
  const { storePlatform } = useParams<{
    storePlatform: "app-store" | "play-store";
  }>();

  const STORE_NAME =
    storePlatform === "app-store"
      ? "App Store"
      : storePlatform === "play-store"
      ? "Play Store"
      : "Store";

  const handleOpenStore = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    const APP_STORE_WEB =
      "https://apps.apple.com/app/id6471098945?action=write-review";
    const PLAY_STORE_WEB =
      "https://play.google.com/store/apps/details?id=io.physiofit.production&pli=1";

    const APP_STORE_APP =
      "itms-apps://apps.apple.com/app/id6471098945?action=write-review";
    const PLAY_STORE_APP = "market://details?id=io.physiofit.production&pli=1";

    let url;

    if (storePlatform === "app-store") {
      url = isIOS ? APP_STORE_APP : APP_STORE_WEB;
    } else {
      url = isAndroid ? PLAY_STORE_APP : PLAY_STORE_WEB;
    }

    console.log("Opening store URL:", url);

    window.open(url, "_blank");
    navigate("completed");
  };

  const handleSkip = () => {
    navigate("completed");
  };

  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText
          headline="Was gefällt dir an der Physiofit-App?"
          text={[
            `Wir würden uns sehr freuen, wenn du uns im ${STORE_NAME} bewertest.`,
          ]}
        />
        <ButtonGroup
          mainButton={{
            text: "Physiofit jetzt bewerten",
            onClick: handleOpenStore,
          }}
          textButton={{
            text: "Später bewerten",
            onClick: handleSkip,
          }}
        />
      </PageContentContainer>
    </PageContainer>
  );
};
